import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IDocumentsResult } from "./types";
import { serverResponse } from "./validators";

interface IFetchDocumentsProps {
  query: string;
}

export async function fetchDocuments({
  query,
}: IFetchDocumentsProps): Promise<IDocumentsResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/cms/documents?${query}`,
    {
      validator: serverResponse,
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(
    result.value.filter(({ state }) => {
      return state === "PUBLISHED";
    }),
  );
}
